export default "/images/vendor/@coreui/icons/svg/flag/cif-cl.svg?b32fbe28f3e0ecfa40a6719e2887bd94";